import React from "react";
const OverridablePortalsContext = React.createContext(null);
OverridablePortalsContext.displayName = "OverridablePortalsContext";
export default OverridablePortalsContext;
